import { ModelName } from '@casops/store/api';
import { useTranslation } from 'react-i18next';
import { useFormEditMode } from './useFormEditMode';

export const useModelFormTitle = (modelName: ModelName, editModeOverride?: boolean) => {
  const { t } = useTranslation();

  const editMode = useFormEditMode(editModeOverride);

  return t(`Model.${editMode ? 'Edit' : 'Create'}.Title`, { modelName });
};
